<template>
  <div class="pendencies">
    <div class="head row align-center column-s">
      <h1><!-- <i class="fa fa-list-check" />  -->Pendências</h1>
      &nbsp;&nbsp;&nbsp;
      <Button
        :layout="showForm ? 'red-go' : 'green-go'"
        title="NOVa PENDÊNCIA"
        @click="showForm = !showForm"
        >{{ showForm ? "x" : "+" }}</Button
      >
      &nbsp;&nbsp;&nbsp;&nbsp;
      <form
        v-if="showForm"
        class="row justify-space align-center-s align-center column-s grid-10"
        onsubmit="return false"
        @submit="newPendency"
      >
        <div class="column grid-3 grid-12-s">
          <label>Nome</label>
          <input class="input" placeholder="Nome" v-model="form.nome" required />
        </div>
        <div class="column grid-4 grid-12-s">
          <label>Operação</label>
          <input class="input" placeholder="Operação" v-model="form.operacao" required />
        </div>
        <div class="column grid-4 grid-12-s">
          <label>URL</label>
          <input class="input" placeholder="URL" v-model="form.url" required />
        </div>
        <div class="column grid-3 grid-12-s">
          <label>Descrição</label>
          <input
            class="input"
            placeholder="Descrição"
            v-model="form.descricao"
            required
          />
        </div>

        <Button layout="green-go" type="submit" :loader="loader.form">ADICIONAR</Button>
      </form>
    </div>

    <div class="list">
      <div v-if="loader.pendencies" class="column align-center justify-center">
        <Loader layout="small" />
      </div>
      <template v-else>
        <input class="input search" v-model="search" placeholder="Pesquisar" />

        <div class="head row justify-space">
          <div class="grid-4">NOME</div>
          <div class="grid-4">OPERAÇÃO</div>
          <div class="grid-2">CRIADO</div>
          <div class="grid-2 hide-s">ALTERADO</div>
        </div>
        <div class="content">
          <div v-for="(pend, i) of filtered" :key="'pend' + i">
            <div class="line row justify-space" @click="toggle(i)">
              <div class="grid-4">{{ pend.nome }}</div>
              <div class="grid-4">{{ pend.operacao }}</div>
              <div class="grid-2">{{ pend.criado_em | date }}</div>
              <div class="grid-2 hide-s">{{ pend.alterado_em | date }}</div>
            </div>
            <div v-if="pend.show" class="edit row wrap column-s">
              <div class="column grid-6 grid-12-s">
                <label>Nome</label>
                <input v-model="pend.nome" placeholder="Nome" />
              </div>
              <div class="column grid-6 grid-12-s">
                <label>Operação</label>
                <input v-model="pend.operacao" placeholder="Operação" />
              </div>
              <div class="column grid-6 grid-12-s">
                <label>URL</label>
                <input v-model="pend.url" placeholder="URL" />
              </div>
              <div class="column grid-6 grid-12-s">
                <label>Descrição</label>
                <input v-model="pend.descricao" placeholder="Operação" />
              </div>
              <div class="column grid-6 grid-12-s">
                <label>Criado por</label>
                <div>{{ pend.nome_criado_por }} em {{ pend.criado_em | date }}</div>
              </div>
              <div class="column grid-6 grid-12-s" v-if="pend.nome_alterado_por">
                <label>Alterado por</label>
                <div>{{ pend.nome_alterado_por }} em {{ pend.alterado_em | date }}</div>
              </div>
              <div class="controls row grid-12 justify-center">
                <br /><br />
                <Button @click="edit(pend)" :loader="loader.form" layout="green-go"
                  ><i class="fa fa-edit" />ATUALIZAR</Button
                >&nbsp;&nbsp;&nbsp;
                <Button @click="del(pend)" :loader="loader.form" layout="red-go"
                  ><i class="fa fa-trash" /> APAGAR</Button
                >
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import Button from "@/components/Button.vue";

export default {
  name: "Pendencies",
  components: { Loader, Button },
  data() {
    return {
      pendencies: [],
      loader: {
        pendencies: true,
        form: false,
      },
      showForm: false,
      search: "",
      form: {
        nome: "",
        descricao: "",
        url: "",
        operacao: "",
      },
    };
  },

  methods: {
    ...mapActions("admin", [
      "PENDENCIES_LIST",
      "PENDENCIES_NEW",
      "PENDENCIES_UPDATE",
      "PENDENCIES_DEL",
    ]),

    async load_pendencies() {
      this.loader.pendencies = true;
      await this.PENDENCIES_LIST().then(({ data }) => (this.pendencies = data));
      this.loader.pendencies = false;
    },
    async newPendency() {
      this.loader.form = true;
      await this.PENDENCIES_NEW(this.form).then(() => this.load_pendencies());
      this.loader.form = false;
    },
    async del(pend) {
      if (confirm(`Deseja excluir ${pend.nome}?`)) {
        this.loader.form = true;
        await this.PENDENCIES_DEL(pend).then(({ status }) => {
          if (status == 200) this.load_pendencies();
        });
        this.loader.form = false;
      }
    },
    async edit(pend) {
      this.loader.form = true;
      await this.PENDENCIES_UPDATE(pend).then(({ status }) => {
        if (status == 200) this.load_pendencies();
      });
      this.loader.form = false;
    },
    toggle(index) {
      this.pendencies[index].show = !this.pendencies[index].show;
      this.pendencies = [...this.pendencies];
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("pendencies");
    this.load_pendencies();
  },
  computed: {
    filtered() {
      if (this.search) {
        const search = this.search.toLowerCase();

        return this.pendencies.filter((part) => {
          let partsSerialize = JSON.stringify(part).toLowerCase();
          return partsSerialize.includes(search);
        });
      } else {
        return this.pendencies;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import "@/assets/scss/vars.scss"
.pendencies
  padding: 42px 35px
  @media (max-width: $small)
    padding: 7px

  .head
    form
      margin-top: -12px
      .input
        width: 90%
      label
        @include label
        @media (max-width: $small)
          margin-top: 21px
      button
        margin-top: 19px
        width: 170px
        @media (max-width: $small)
          margin: 33px 0
          width: 96%
  .list
    background: white
    margin-right: 12px
    border-radius: 21px
    margin-top: 19px
    padding: 23px
    min-height: 300px
    @include border
    @media (max-width: $small)
      margin: 19px 5%
    .loader
      margin: auto
      margin-top: 120px
    label, .head
      @include label
    .head
      padding-bottom: 19px
    .search
      width: 400px
      height: 40px
      margin-bottom: 50px
      border-bottom: 1.9px solid #999
      box-shadow: none
      border-radius: 0
      &:focus
        border-bottom: 1.9px solid $supporter-1
        color: $supporter-1
        background: none
      @media (max-width: $small)
        width: 100%
    .content
      max-height: 400px
      overflow-y: auto
      .line
        padding: 17px 6px
        border-radius: 23px
        &:hover
          color: white
          background: $purple
          cursor: pointer
      .edit
        background: #eee
        padding: 30px 12px
        border-radius: 23px
        @include border
        input
          width: 80%
          margin-bottom: 30px
        .controls
          margin-top: 43px
</style>
